<template>
  <main>
    <v-toolbar style="background-color: #444; color: #fff; border-radius: 5px">
      <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
    </v-toolbar>
    <v-form @submit.prevent="handleSubmit">
      <formWrapper :validator="$v.form">
        <v-container>
          <v-row>
            <v-col cols="12">
              <locale-select v-if="isEdit" v-model="locale" @change="changeLocale" />
            </v-col>
            <v-col cols="12">
              <span>{{ $t("labels.photo") }}</span>

              <section class="file-upload">
                <new-image-upload class="file-upload__image" :imgUrl="form.photo ? form.photo.path : ''"
                  :imgId="form.photo ? form.photo.id : ''" @fileSelected="onPhotoSelect" :checkRatio="false"
                  :maxSize="maxSize" />
              </section>
            </v-col>
            <!-- <v-col cols="12">
              <span>{{ $t("labels.bg_photo") }}</span>

              <section class="file-upload">
                <new-image-upload
                  class="file-upload__image"
                  :imgUrl="form.bg_photo ? form.bg_photo.path : ''"
                  :imgId="form.bg_photo ? form.bg_photo.id : ''"
                  @fileSelected="onBgPhotoSelect"
                  :checkRatio="false"
                  :maxSize="maxSize"
                />
              </section>
            </v-col> -->
            <v-col cols="12">
              <span>{{ $t("labels.media") }}</span>
              <section class="file-upload__gallery pa-0">
                <multi-image-upload class="file-upload__gallery--upload" :maxSize="mediaSize"
                  @fileSelected="handleMultiPhotos" @handle_delete_image="onDeleteImage" :imgsUrl="imgsUrl" />
              </section>
            </v-col>
            <v-col cols="12">
              <first-step :isEdit="isEdit" :form="form" />
            </v-col>

            <v-col cols="12">
              <CustomEditor :placeholder="$t('fields.description')" class="editor" :form="form"
                fieldName="description" />
            </v-col>

            <v-col cols="12">
              <v-btn :disabled="$v.form.$invalid" :loading="loadingButton" type="submit" class="primary" large block
                rounded>{{ $t("button.save") }}
                <v-icon>mdi-content-save</v-icon>
              </v-btn>
            </v-col>
            <!-- :disabled="$v.form.$invalid" -->
          </v-row>
        </v-container>
      </formWrapper>
    </v-form>
  </main>
</template>

<script>
import { VueEditor } from "vue2-editor";
import {
  required,
  minLength,
  maxLength,
  minValue,
  maxValue
} from "vuelidate/lib/validators";
import { maxWords } from "@/utils/validate";
import { StoreData, ShowData, UpdateData } from "@/helpers/apiMethods";

export default {
  name: "CreateAndEditTrip",
  components: {
    FirstStep: () => import("./first_step"),
    VueEditor
  },
  provide() {
    return {
      $v: this.$v
    };
  },
  data() {
    return {
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ align: "" }, { align: "justify" }, { align: "right" }],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ direction: "rtl" }]
      ],
      maxSize: 1.24,
      mediaSize: 0.512,
      loadingButton: false,
      locale: this.locale,
      program: {},
      form: {
        name: "",
        description: "",
        min_persons_count: "",
        max_persons_count: "",
        photo: "",
        priority: 1,
        visible: 0
      },
      media: [],
      imgsUrl: []
    };
  },
  computed: {
    formTitle() {
      if (this.$route.name === "create-carClassification") {
        return this.$t("heading.create");
      } else {
        return this.$t("heading.edit");
      }
    },
    isEdit() {
      if (this.$route.name === "create-carClassification") {
        return false;
      } else {
        return true;
      }
    }
  },

  methods: {
    onPhotoSelect({ file }) {
      this.form.photo = file;
    },
    onBgPhotoSelect({ file }) {
      this.form.bg_photo = file;
    },

    handleShowData(locale = this.locale) {
      ShowData({
        reqName: "car-classifications",
        param: this.$route.params.slug,
        locale
      }).then(res => {
        const { car_classification } = res.data;
        this.imgsUrl = car_classification.media.filter(el => !el.main);
        this.media = [...this.imgsUrl];
        this.form.photo = car_classification.photo;
        for (const key in this.form) {
          this.form[key] = car_classification[key];
        }
        this.form.visible = car_classification.visible ? 1 : 0;
      });
    },
    generateData() {
      const formData = new FormData();

      if (this.isEdit) {
        delete this.form.bg_photo;
      }
      if (this.form.photo) {
        if (this.form.photo["id"]) {
          delete this.form.photo;
        }
      }
      if (this.media && this.media.length > 0) {
        // eslint-disable-next-line prettier/prettier
        this.media.forEach(media => {
          if (!media.id) formData.append("media[]", media);
        });
      }

      for (const key in this.form) {
        if (this.form[key] !== null && this.form[key] !== "null") {
          formData.append(key, this.form[key]);
        }
      }
      if (this.isEdit) {
        formData.append("_method", "put");
        formData.append("locale", this.locale);
      }
      return formData;
    },
    onCreate() {
      StoreData({ reqName: "car-classifications", data: this.generateData() })
        .then(() => {
          this.$router.push("/car/classifications");
        })
        .finally(() => {
          this.loadingButton = false;
        });
    },
    onUpdate() {
      UpdateData({
        reqName: "car-classifications",
        data: this.generateData(),
        param: this.$route.params.slug,
        locale: this.locale
      })
        .then(() => {
          this.$router.push("/car/classifications");
        })
        .finally(() => {
          this.loadingButton = false;
        });
    },
    handleSubmit() {
      this.loadingButton = true;

      if (!this.isEdit) {
        // in case create
        this.onCreate();
      } else {
        // in case edit
        this.onUpdate();
      }
    },
    changeLocale(locale) {
      this.locale = locale;
      this.handleShowData(locale);
    },

    handleMultiPhotos(files) {
      if (!this.media) {
        this.media = [];
      }
      this.media = [...this.media, ...files];
    },
    onDeleteImage(index) {
      this.media.splice(index);
    }
  },
  validations() {
    return {
      form: {
        name: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(150)
        },
        description: {
          maxWords: maxWords(2000)
        },
        min_persons_count: {
          required,
          minValue: minValue(1),
          maxValue: maxValue(Number(this.form.max_persons_count - 1))
        },
        max_persons_count: {
          required,
          minValue: minValue(Number(this.form.min_persons_count + 1)),
          maxValue: maxValue(50)
        },
        priority: {
          minValue: minValue(1)
        }
      }
    };
  },

  watch: {
    isEdit: {
      handler(value) {
        if (value) {
          this.handleShowData();
        }
      },
      immediate: true
    }
  }
};
</script>
